import { combineReducers } from 'redux'
import errorReducer from './errorReducer'
import loginReducer from './loginReducer'
import pgmReducer from './pgmReducer'
import profileReducer from './profileReducer'
import questionaireReducer from './questionaireReducer'
import moduleReducer from './moduleReducer'
import SearchpgmReducer from './pgmsearchReducer'
import ActivebtnReducer from './productTrainingbtnReducer'
import PagepgmReducer from './pgmpageReducer'
import PartlistSearchValueReducer from './partlistSearchinputReducer'
import PartlistPageReducer from './partlistPageinputReducer'
import PartCataloguePageinputReducer from './partCataloguePageinputReducer'
import tutorialSearchValueReducer from './tutorialSearchinputReducer'
import orderListSearchValueReducer from './orderListSearchinputReducer'
import orderListPageValueReducer from './orderListPageinputReducer'
import moduleSearchValueReducer from './moduleSearchReducer'
import modulePageReducer from './moduleListPageReducer'
import tutorialPageReducer from './tutorialListPageReducer'
import pgmFilterButtonReducer from './pgmFIlterButtonReducer'
import partListSortReducer from './partlistsortreducer'
import orderListSortReducer from './orderlistsortreducer'
import permissionsReducer from './permissionReducer'
import createRoleReducer from './createRoleReducer'
import { deleteRoleReducer } from './deleteRoleReducer'
import getUpdateRolesReducer from './getUpdateRolesReducer'
import createUserReducer from './createUserReducer'
import getEmployeeReducer from './getEmppoyeeReducer'
import { getUserDetailReducer } from './getUserDetail'
import { deleteUserReducer } from './deleteUserReducer'
import {updateUserReducer} from './updateUserReducer'
import { getStatesReducer } from './getStatesReducer'
import createAreaExecutiveReducer from './createAreaExecutiveReducer'
import getAreaExecutiveListReducer from './getAreaExecutiveListReducer'
import { deleteAreaExecutiveReducer } from './deleteAreaExecutiveReducer'
import { getAreaExecutiveDetailReducer } from './getAreaExecutiveDetailReducer'
import { updateAreaExecutiveReducer } from './updateAreaExecutive'
import { rolesReducer } from './rolesReducer';
import { userToggleStatusReducer } from './userSwitchReducer'
import { areaExecutiveToggleStatusReducer } from './areaExecutiveSwitchReducer'
import getGroupReducer from './getGroupReducer';
import { pgmDiscountGroupUpdateReducer } from './pgmDiscountGroupUpdateReducer';
import createScheduleNotificationReducer from './createNotificationReducer'
import { notificationDetailsReducer } from './notificationDetailsReducer'
import getUserGroupReducer from './getUserGroupReducer'
import getRedirectionPageReducer from './getRedirectionPageReducer'
import getNotificationListReducer from './getNotificationListReducer'
import createBulkScheduleNotificationReducer from './createBulkNotificationReducer'
import { updateNotificationReducer } from './updateScheduleNotificationReducer'
import { bulkNotificationDetailsReducer } from './bulkNotificationReducer'
import { updateBulkNotificationReducer } from './updateBulkNotificationReducer'

export default combineReducers({
  errors: errorReducer,
  login: loginReducer,
  pgm: pgmReducer,
  profile: profileReducer,
  question:questionaireReducer,
  modulecreated:moduleReducer,
  pgmsearch:SearchpgmReducer,
  activecomponent:ActivebtnReducer,
  pgmlistpage:PagepgmReducer,
  partlistSearch:PartlistSearchValueReducer,
  partlistPage:PartlistPageReducer,
  partlistSort:partListSortReducer,
  orderlistSort:orderListSortReducer,
  partCatalougePage:PartCataloguePageinputReducer,
  tutorialSearch:tutorialSearchValueReducer,
  orderListSearch:orderListSearchValueReducer,
  orderListPage:orderListPageValueReducer,
  moduleSearch:moduleSearchValueReducer,
  modulePage:modulePageReducer,
  tutorialPage:tutorialPageReducer,
  pgmButton:pgmFilterButtonReducer,
  permissions: permissionsReducer,
  createRoleReducer: createRoleReducer,
  deleteRoleReducer: deleteRoleReducer,
  getUpdateRolesReducer: getUpdateRolesReducer,
  createUserReducer:createUserReducer,
  getEmployeeReducer:getEmployeeReducer,
  getUserDetailReducer:getUserDetailReducer,
  deleteUserReducer:deleteUserReducer,
  updateUserReducer:updateUserReducer,
  getStatesReducer:getStatesReducer,
  createAreaExecutiveReducer:createAreaExecutiveReducer,
  getAreaExecutiveListReducer:getAreaExecutiveListReducer,
  deleteAreaExecutiveReducer:deleteAreaExecutiveReducer,
  getAreaExecutiveDetailReducer:getAreaExecutiveDetailReducer,
  updateAreaExecutiveReducer:updateAreaExecutiveReducer,
  rolesReducer:rolesReducer,
  userToggleStatusReducer:userToggleStatusReducer,
  areaExecutiveToggleStatusReducer:areaExecutiveToggleStatusReducer,
  getGroupReducer:getGroupReducer,
  pgmDiscountGroupUpdateReducer:pgmDiscountGroupUpdateReducer,
  createScheduleNotificationReducer:createScheduleNotificationReducer,
  notificationDetailsReducer:notificationDetailsReducer,
  getUserGroupReducer:getUserGroupReducer,
  getRedirectionPageReducer:getRedirectionPageReducer,
  getNotificationListReducer:getNotificationListReducer,
  createBulkScheduleNotificationReducer:createBulkScheduleNotificationReducer,
  updateNotificationReducer:updateNotificationReducer,
  bulkNotificationDetailsReducer:bulkNotificationDetailsReducer,
  updateBulkNotificationReducer:updateBulkNotificationReducer
})
